import entityBase from "entityBase";
import * as ko from "knockout";
import { changeTracker } from "entitiesE";

export class PartUsage extends entityBase {
  pu_id: KnockoutObservable<string>;
  part_line_code: KnockoutObservable<string>;
  part_line_code_desc: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>; // replaced new part ID
  old_part_id: KnockoutObservable<string>; // replaced new part ID
  serial_no_defective: KnockoutObservable<string>;
  serial_no_new: KnockoutObservable<string>;
  old_quantity: KnockoutObservable<string>;
  quantity: KnockoutObservable<string>;
  defective_part: KnockoutObservable<any>;
  user_def1: KnockoutObservable<string>; // replaced_part serial
  user_def8: KnockoutObservable<string>;
  user_def9: KnockoutObservable<string>;
  old_user_def9: KnockoutObservable<string>;
  user_def13: KnockoutObservable<string>; // -- compensation type
  place_id_from: KnockoutObservable<string>; // -- placeID
  user_def15: KnockoutObservable<string>; //-- Service model

  location: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  unit_price: KnockoutObservable<string>;

  entityState: () => { isDirty: KnockoutComputed<boolean>; markCurrentStateAsClean: () => void };
  is_new: KnockoutObservable<boolean>;
  serial_id: KnockoutObservable<string>;
  old_serial_id: KnockoutObservable<string>;
  user_def17: KnockoutObservable<string>;

  constructor(item) {
    super();
    this.user_def17 = ko.observable(item.user_def17);
    this.part_line_code_desc = ko.observable();
    if (item.part_line_code)
      if (item.part_line_code instanceof Array) {
        var i: number;
        i = 0;
        for (i = 0; i < item.part_line_code.length; i++) {
          if (item.part_line_code[i] instanceof Object) {
            this.part_line_code = ko.observable(item.part_line_code[i].part_line_code);
            this.part_line_code_desc = ko.observable(item.part_line_code[i].description);
            break;
          }
        }
      } else {
        this.part_line_code = ko.observable(item.part_line_code);
      }
    this.pu_id = ko.observable(item.pu_id);
    this.task_id = ko.observable(item.task_id);
    this.part_id = ko.observable(item.part_id);
    this.old_part_id = ko.observable(item.part_id);
    this.part_id.subscribe((newval: any) => {
      if (newval) {
        if (newval.toString() != "[object Object]") {
          this.old_part_id(newval);
        } else if (newval) {
          this.old_part_id(newval.part_id);
        }
      }
    });
    this.serial_no_defective = ko.observable(item.user_def1);
    this.serial_no_new = ko.observable();
    if (item.part_usage_serial) this.serial_no_new = ko.observable(item.part_usage_serial.serial_id);

    this.quantity = ko.observable(item.quantity ? item.quantity : "1");
    this.old_quantity = ko.observable(item.quantity ? item.quantity : "0");
    this.user_def1 = ko.observable(item.user_def1);
    this.user_def8 = ko.observable(item.user_def8);
    this.user_def13 = ko.observable(item.user_def13);
    this.user_def15 = ko.observable(item.user_def15);
    this.place_id_from = ko.observable(item.place_id_from);
    this.defective_part = ko.observable();
    this.defective_part.subscribe((newval) => {
      this.part_id(newval.part_id);
      this.user_def1(newval.descr);
    });

    this.entityState = changeTracker(this);
    this.is_new = ko.observable(item?.is_new);
    this.location = ko.observable(item.location);
    this.description = ko.observable();
    if (item.part) this.description = ko.observable(item.part.internal_descriptn);
    this.unit_price = ko.observable(item.bill_price);
    this.user_def9 = ko.observable(item.user_def9);
    this.old_user_def9 = ko.observable(item.user_def9);
    this.user_def9.subscribe((newval: any) => {
      if (newval) {
        if (newval.toString() != "[object Object]") {
          this.old_user_def9(newval);
        } else {
          this.old_user_def9(newval.part_id);
        }
      }
    });
    this.serial_id = ko.observable();
    this.old_serial_id = ko.observable();
    if (item.part_usage_serial) {
      this.serial_id = ko.observable(item.part_usage_serial.serial_id);
      this.old_serial_id = ko.observable(item.part_usage_serial.serial_id);
    }
  }
}
